import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BackendAuthService } from './backend-auth.service';

@Injectable()
export class BackendAuthInterceptor implements HttpInterceptor {
  constructor(private backendAuth: BackendAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const baseUrl = (environment.apiConfig?.baseUrl ?? '').toString();
    const isAbsoluteBackendRequest = !!baseUrl && req.url.startsWith(baseUrl);
    const isRelativeBackendRequest = (() => {
      if (baseUrl) return false;

      // HttpClient may keep relative URLs ('/enac/...') or normalize to an absolute same-origin URL.
      if (req.url.startsWith('/enac/') || req.url === '/enac') return true;

      try {
        const u = new URL(req.url, window.location.origin);
        return u.origin === window.location.origin && (u.pathname.startsWith('/enac/') || u.pathname === '/enac');
      } catch {
        return false;
      }
    })();
    const isBackendRequest = isAbsoluteBackendRequest || isRelativeBackendRequest;

    if (!isBackendRequest || req.headers.has('Authorization')) {
      return next.handle(req);
    }

    return from(this.backendAuth.getBackendToken()).pipe(
      switchMap(token => {
        const authReq = req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
        return next.handle(authReq);
      }),
      catchError(error => throwError(() => error))
    );
  }
}
